import {AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {EvkFormComponentBase, validateEmptyField} from '@evomatik/evk-common';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'lib-motivo-rechazo-form',
    templateUrl: './motivo-rechazo-form.component.html',
    styleUrls: ['./motivo-rechazo-form.component.scss']
})
export class MotivoRechazoFormComponent extends EvkFormComponentBase <any> implements OnInit, AfterViewChecked {

    @Input() public idDiligencia: string;
    @Input() public idDiligenciaConfig: string;
    @Input() public createdBy: string;
    @Input() public diligencia: any;
    @Input() public clasificacion: any;

    form: FormGroup;

    constructor(
        public fb: FormBuilder,
        public changeDetector: ChangeDetectorRef,
    ) {
        super(fb);
    }

    protected get formBuild(): FormGroup {
        return this.fb.group({
            id: this.idDiligencia,
            createdBy: this.createdBy,
            clasificacion: this.clasificacion,
            idDiligenciaConfig: this.idDiligenciaConfig,
            observaciones: ['', [Validators.required, validateEmptyField]],
        });
    }

    ngOnInit() {
        this.form = this.formBuild;
    }

    ngAfterViewChecked(): void {
        this.changeDetector.detectChanges();
    }
}
